import React from "react";
import { Redirect, Route } from "react-router-dom";

const MaintenancePrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                localStorage.getItem("maintenance-token") !== null ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/maintenance-login",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

export default MaintenancePrivateRoute;
